import React, { Component } from 'react';
import {
    List,
    EditButton,
    Pagination,
    Datagrid,
    TextField,
    BooleanField,
    Edit,
    Create,
    SimpleForm,
    TextInput,
    BooleanInput,
    DateField,
    DateInput
} from 'react-admin';

class PlatePandoraList extends Component {
    render() {
        return (
            <List title="Plate Pandora Factors" {...this.props} pagination={<Pagination rowsPerPageOptions={[10, 25, 50, 100]} />}>
                <Datagrid>
                    <TextField source="baseVersion"></TextField>
                    <BooleanField source="isTest"></BooleanField>
                    <BooleanField source="isCurrent"></BooleanField>
                    <DateField label="Release Date" source="date"></DateField>
                    <EditButton />
                </Datagrid>
            </List>
        );
    }
}

class PlatePandoraEdit extends Component {
    render() {
        return (
            <Edit title="Plate Pandora Factors" {...this.props} redirect="/HEXSelector/PlatePandora/">
                <SimpleForm>
                    <TextInput label="Current Version" source="baseVersion"></TextInput>
                    <BooleanInput label="Current Version" source="isCurrent"></BooleanInput>
                    <BooleanInput label="Test Version" source="isTest"></BooleanInput>
                    <TextInput disabled label="AHRI Version" source="plAHRIVersion"></TextInput>
                    <DateInput disabled source="date"></DateInput>
                </SimpleForm>
            </Edit>
        )
    }
}

export { PlatePandoraList, PlatePandoraEdit }
